<div class="system-banners-wrapper" *ngIf="banners.length > 0">

  <!-- Expanded state: full list of banners -->
  <div class="system-banners-stack" *ngIf="!isCollapsed">
    <div
      class="system-banner"
      *ngFor="let banner of banners; trackBy: trackByBannerId"
      [ngClass]="'system-banner-' + banner.style"
    >
      <mat-icon class="system-banner-icon material-icons-outlined">{{ getIconForStyle(banner.style) }}</mat-icon>

      <div class="system-banner-content" [innerHTML]="banner.content"></div>

      <button
        *ngIf="banner.is_dismissible"
        mat-icon-button
        class="system-banner-dismiss"
        (click)="onDismiss(banner)"
        aria-label="Dismiss banner"
        matTooltip="Dismiss"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Collapsed state: compact summary row with one icon per distinct style -->
  <div class="system-banners-summary" *ngIf="isCollapsed" (click)="toggleCollapsed()">
    <div class="system-banners-summary-icons">
      <mat-icon
        *ngFor="let style of getDistinctStyles(); trackBy: trackByStyle"
        [ngClass]="'system-banners-summary-icon material-icons-outlined system-banner-icon-' + style"
      >{{ getIconForStyle(style) }}</mat-icon>
    </div>
    <span class="system-banners-summary-text">
      {{ banners.length }}
      {{ banners.length === 1 ? 'notification' : 'notifications' }}
    </span>
  </div>

  <!-- Toggle control, centered below the stack -->
  <div class="system-banners-toggle-wrapper" *ngIf="banners.length > 1 || banners.length === 1">
    <button
      type="button"
      mat-button
      class="system-banners-toggle"
      (click)="toggleCollapsed()"
      [attr.aria-expanded]="!isCollapsed"
    >
      <mat-icon class="system-banners-toggle-icon">
        {{ isCollapsed ? 'expand_more' : 'expand_less' }}
      </mat-icon>
      <span>{{ isCollapsed ? 'Show' : 'Hide' }}</span>
    </button>
  </div>

</div>
